<template>
  <div class="lds-ring">
    <div :style="[{'border-width': borderWidth}]"></div>
    <div :style="[{'border-width': borderWidth}]"></div>
    <div :style="[{'border-width': borderWidth}]"></div>
    <div :style="[{'border-width': borderWidth}]"></div>
  </div>
</template>

<script>
  export default {
    name: 'ring-loader',
    props: {
      borderWidth: {
        type: String,
        default: function () {
          return '2px'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 100%;
    height: 100%;
    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      margin: 6px;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-style: solid;
      border-color: $primary-color-v2 transparent transparent transparent;
      &:nth-child(1) {
        animation-delay: -0.45s;
      }
      &:nth-child(2) {
        animation-delay: -0.3s;
      }
      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/RingLoader.vue